// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"vendor":1,"react":1}[chunkId]) return "static/js/" + chunkId + ".js";
	// return url for filenames based on template
	return "static/js/" + {"src_apps_configurator_containers_Parts_index_jsx":"16681792","src_Icons_shapes_custom_DK_svg":"f3ea356d","src_Icons_shapes_custom_NO_svg":"5825b9e1","src_Icons_shapes_custom_IT_svg":"ddc820f7","src_Icons_shapes_custom_PL_svg":"86f16d1e","src_Icons_shapes_custom_PT_svg":"2a2cefb8","src_Icons_shapes_custom_SE_svg":"b9e71c9c"}[chunkId] + ".chunk.js";
};